
import { useEffect, useState } from "react";
import AddPaymentPopup from "src/sections/payment/AddPaymentPopup";
import UpdateRiderPaymentPopup from "src/sections/payment/UpdateRiderPaymentPopup";
import rideService from "src/services/rideService";

export default function PaymentDetails({ riderId, isOpen, onClose }) {


  const [allPayment, setAllPayment] = useState([]);

  const [totalCommissionAmount, setTotalCommissionAmount] = useState();
  const [totalCommissionPaidAmount, setTotalCommissionPaidAmount] = useState();
  const [totalRideAmount, setTotalRideAmount] = useState();
  const [isAddPopupOpen, setIsAddPopupOpen] = useState();
  const [isUpdatePopupOpen, setIsUpdatePopupOpen] = useState();
  const [paymentId, setPaymentId] = useState();
  const [paidAmount, setPaidAmount] = useState('');
  useEffect(() => {

    rideService.getCommissionOfRider(riderId).then((res) => {
      if (res.status == 200) {
        setAllPayment(res.data.completedRides);
        setTotalCommissionAmount(res.data.totalCommission);
        setTotalCommissionPaidAmount(res.data.totalCommissionPaid);
        setTotalRideAmount(res.data.totalEarning);

      }
    })
  }, [])




  const handleClosePopup = () => {
    setIsAddPopupOpen(false);

  };
  const handleUpdate = () => {
    // Perform the update logic here

  };

  const handleAddOpenPopup = () => {
    setIsAddPopupOpen(true);
  };

  const handleUpdateOpenPopup = (paymentId, paidAmount) => {
    setIsUpdatePopupOpen(true);
    setPaymentId(paymentId);
    setPaidAmount(paidAmount);
  };

  const handleUpdateClosePopup = () => {
    setIsUpdatePopupOpen(false);

  };

  const handleDeleteCommissionPayment = (paymentId) => {
    rideService.deleteCommissionPayment(paymentId).then((res) => {
      if (res.status == 200) {
          window.location.reload();
      }
    })
  };
  return (
    <>
      <div className={`fixed inset-0 ${isOpen ? 'block' : 'hidden'}`}>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 flex items-center justify-center">

          <div className="bg-white p-6 rounded-lg shadow-lg max-h-full overflow-y-auto w-auto">
            <button
              className="bg-green-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-20"
              onClick={() => handleAddOpenPopup()}
            >
              Add Payment
            </button>
            <AddPaymentPopup
              isOpen={isAddPopupOpen}
              onClose={handleClosePopup}
              onSubmit={handleUpdate}
              riderId={riderId}
              totalCommissionAmount={totalCommissionAmount}
              totalCommissionPaidAmount={totalCommissionPaidAmount}
            />

            <UpdateRiderPaymentPopup
              isOpen={isUpdatePopupOpen}
              onClose={handleUpdateClosePopup}
              onSubmit={handleUpdate}
              paymentId={paymentId}
              paidAmount={paidAmount}
            />
            <h1 className="text-2xl font-bold text-center">{totalRideAmount}</h1>
            <table className="min-w-full mt-10">
              <thead>
                <tr className="bg-blue-500 text-white">
                  <th className="px-4 py-2 text-left border-b border-r border-gray-300">ID</th>
                  <th className="px-4 py-2 border-b border-r border-gray-300">Paid Amount</th>
                  <th className="px-4 py-2 border-b border-gray-300">Date</th>
                  <th className="px-4 py-2 border-b border-gray-300">Action</th>
                </tr>
              </thead>
              <tbody className="text-gray-600">
                {allPayment.map((payment) => {
                  const dateString = payment.created_at; // Assuming 'created_at' is in ISO 8601 format
                  const dateObject = new Date(dateString);
                  const formattedDate = dateObject.toLocaleDateString();
                  const formattedTime = dateObject.toLocaleTimeString();
                  const dateTimeString = `${formattedDate} ${formattedTime}`;
                  return (
                    <tr key={payment.id} className="border-b border-gray-200 hover:bg-gray-100">
                      <td className="px-4 py-2 border-r border-gray-300 text-center">{payment.id}</td>
                      <td className="px-4 py-2 border-r border-gray-300 text-center">{payment.paid_amount}</td>
                      <td className="px-4 py-2 text-center">{dateTimeString}</td>
                      <td className="px-4 py-2 text-center">
                        <button
                          className="bg-green-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                          onClick={() => handleUpdateOpenPopup(payment.id, payment.paid_amount)}
                        >
                          Update
                        </button>
                        <button
                          className=" ml-10 bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                          onClick={() => handleDeleteCommissionPayment(payment.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );

                })}
              </tbody>
            </table>
            <button
              onClick={onClose}
              className="bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Close
            </button>
          </div>
        </div>
      </div>

    </>
  );
}

// export async function getServerSideProps(context) {
//   const { riderId } = context.query;

//   return {
//     props: {
//       riderId: riderId || null, // Handle the case where id is undefined
//     },
//   };
// }